import { useQuery } from '@tanstack/react-query'
import { statsApi } from '~/entities/stats/api/stats'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function usePublicStats() {
  return useQuery({
    queryKey: queryKey(QueryKey.PUBLIC_STATS),
    queryFn: () => statsApi.getPublicStats(),
    staleTime: 5 * MINUTES,
  })
}
